import { AccountRole } from '../account/account-role';
import { AccountType } from '../account/account-type';
import { Address } from './address';
import { DistanceUnit } from './distance-unit';
import { Identifier } from './identifier';
import { Skill } from './skill';

export class Company implements Identifier {
    public id: string;
    public type: AccountType;
    public name: string;
    public phone: string;
    public email: string;
    public avatar_url: string;
    public description: string;
    public default_radius: number;
    public distance_unit: DistanceUnit;
    public locale: string;
    public timezone: string;
    public onboard: boolean;
    public activated: boolean;
    public lat: number;
    public lng: number;
    public start_day_of_week: number;
    public start_time_of_day: string;
    public appear_in_job_search: boolean;
    public appear_in_shift_search: boolean;
    public appear_in_map_search: boolean;
    public auto_swap_approval: boolean;
    public allow_shift_swaps: boolean;
    public allow_chat: boolean;
    public allow_offsites: boolean;
    public shift_change_cutoff: number;
    public industry_id: number;
    public size: string;
    public reserved_enabled: boolean;
    public updated_at: string;
    public role: AccountRole;
    public recommendations_count: number;
    public loc_count: number;
    public skills_count: number;
    public gallery_count: number;
    public address: Address;
    public skills: Skill[];
    public attendance_enabled: boolean;
    public currency: string;
    public free_history_last_date: string;
}